var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (false)?_c('el-row',{staticClass:"tour",attrs:{"type":"flex","justify":"center"}},[_c('t-circle-button',{attrs:{"type":"default","icon":"el-icon-icon-chopper","pulse":""},on:{"click":_vm.startTour}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }